import { stopTimer } from "./actionCreators";
import { getQuizTestDetails } from "../../QuizStudio/actions";

export const fetchQuizTestDetails = (id) => {
  return (dispatch) => {
    return dispatch(getQuizTestDetails({ quizTest: id, mode: "test" }));
  };
};

export const submitQuizTestTimer = (response) => {
  return (dispatch) => {
    dispatch(stopTimer());
  };
};
